import { render } from "./MathLevelList.vue?vue&type=template&id=64c35dd2&ts=true"
import script from "./MathLevelList.vue?vue&type=script&lang=ts"
export * from "./MathLevelList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__